import { ACCESS, ROLES } from '../constants/permissions/roles.js';
import { ROUTES } from '../constants/routes/routes.js';

const LINKS_PERMISSIONS = {
    main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_links: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_payments: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
};

// This is commented out as per the card's request
// const CARDS_PERMISSIONS = {
//     main: ACCESS.INTERNAL,
//     sub_cards: ACCESS.INTERNAL,
//     sub_movements: ACCESS.INTERNAL,
//     sub_summaries: ACCESS.INTERNAL,
//     sub_collections: ACCESS.INTERNAL,
//     sub_expirations: ACCESS.INTERNAL,
// };

const ACCOUNTS_PERMISSIONS = {
    main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_transactions: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_remunerated: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    sub_earningsSettlement: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
};

export const PERMISSIONS = {
    DOWNLOAD_LIST: 'general.download_list',
};

export const userPermissions = {
    show_dashboards: {
        main: [...ACCESS.INTERNAL, ...ACCESS.FRAUD_PREVENTION, ROLES.userAdmin],
    },
    show_clients: {
        main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_details: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_device: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_telephones: ACCESS.INTERNAL,
        sub_email: ACCESS.INTERNAL,
        sub_address: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        sub_links: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
        // sub_cards: ACCESS.INTERNAL,
        sub_audits: ACCESS.INTERNAL,
        sub_accounts: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL, ...ACCESS.FRAUD_PREVENTION],
    },
    show_products: {
        main: [...ACCESS.INTERNAL, ...ACCESS.EXTERNAL],
        show_links: LINKS_PERMISSIONS,
        show_chargebacks: ACCESS.INTERNAL,
        // This is commented out as per the card's request
        // show_cards: CARDS_PERMISSIONS,
        show_accounts: ACCOUNTS_PERMISSIONS,
    },
    show_reports: {
        main: ACCESS.INTERNAL,
        sub_bcraCustomerAccounts: ACCESS.INTERNAL,
        sub_bankReconciliation: ACCESS.INTERNAL,
        sub_bcra_stats_info: ACCESS.INTERNAL,
        sub_idcExempt: ACCESS.INTERNAL,
        sub_bills: ACCESS.INTERNAL,
        sub_bills_calendar: ACCESS.INTERNAL,
        sub_dailyBalances: ACCESS.INTERNAL,
        sub_accounting_entries: ACCESS.INTERNAL,
        sub_sircupa: ACCESS.INTERNAL,
        sub_sircupa_returns: ACCESS.INTERNAL,
        sub_tax_registers: ACCESS.INTERNAL,
        sub_afip: ACCESS.INTERNAL,
        sub_iibbTucuman: ACCESS.INTERNAL,
        sub_iibbTucuman_tax_register: ACCESS.INTERNAL,

    },
    show_users: [...ACCESS.INTERNAL, ROLES.userAdmin],
    show_management: {
        main: [...ACCESS.ALL, ...ACCESS.FRAUD_PREVENTION],
        sub_cancellations: ACCESS.INTERNAL,
        sub_functionalities: ACCESS.INTERNAL,
        sub_consultants: ACCESS.ALL,
        sub_consultants_load: ACCESS.INTERNAL,
        sub_announcements: ACCESS.INTERNAL,
        sub_antifraud: [...ACCESS.INTERNAL, ...ACCESS.FRAUD_PREVENTION],
    },
};

export const actionPermissions = {
    consultants: {
        load: ACCESS.INTERNAL,
    },
    paymentLinks: {
        link_block_button: ACCESS.ADMIN,
    },
    general: {
        download_list: [...ACCESS.INTERNAL, ...ACCESS.FRAUD_PREVENTION],
    },
    users: {
        create: [ROLES.admin, ROLES.userAdmin],
    }
};

const getUserRole = () => {
    const user = localStorage.getItem('sessionUser');
    if (!user) return null;
    const userRole = JSON.parse(user)?.roles[0];
    const roleId = userRole?.role.id;
    return roleId;
};

export const checkUserPermission = (user, action) => {
    if (!user || !user.roles || !user.roles.length) return false;
    return user.roles.some(userRole => {
        const roleId = userRole.role.id;

        const allPermissions = {
            ...userPermissions,
            ...actionPermissions,
        };
        const keys = action.split('.');
        let current = allPermissions;

        for (const key of keys) {
            if (current && typeof current === 'object') {
                current = current[key];
            }
            else {
                return false;
            }
        }

        return Array.isArray(current) ? current.includes(roleId) : false;
    });
};

export const checkPermissions = (action) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return false;
    }

    const roleId = getUserRole();
    if (!roleId) return false;

    const allPermissions = {
        ...userPermissions,
        ...actionPermissions,
    };
    const keys = action.split('.');
    let current = allPermissions;

    for (const key of keys) {
        if (current && typeof current === 'object') {
            current = current[key];
        }
        else {
            return false;
        }
    }

    return Array.isArray(current) ? current.includes(roleId) : false;
};

export const getDefaultFallbackPath = () => {
    const roleId = getUserRole();
    if (!roleId) return '/logout';
    const role = Object.values(ROLES).find(roleValue => roleValue === roleId);
    if (!role) return '/logout';
    switch (role) {
        case ROLES.admin:
            return ROUTES.CLIENTS.BASE;
        case ROLES.operator:
            return ROUTES.CLIENTS.BASE;
        case ROLES.externalSupport:
            return ROUTES.MANAGEMENT.CONSULTANTS;
        case ROLES.fraudPrevention:
            return ROUTES.MANAGEMENT.PAYMENT_LINKS_RULES;
        case ROLES.fraudPreventionAdmin:
            return ROUTES.MANAGEMENT.PAYMENT_LINKS_RULES;
        case ROLES.userAdmin:
            return ROUTES.USERS.BASE;
        default:
            return '/logout';
    }
};
